export default "__VITE_ASSET__B48fkO4c__"